

import Vue from 'vue';
import helpers from './components/plugins/helpers.js'

Vue.use(helpers)

import App from './app.vue'
import VueRouter from 'vue-router'
import routes from './routes/routes'
import asyncComputed from 'vue-async-computed'
import VueMeta from 'vue-meta'
import globalmethods from './components/plugins/globalmethods.js'
import globalmethods_ssr from './components/plugins/globalmethods_ssr.js'

import SsrCarousel from 'vue-ssr-carousel';
import 'vue-ssr-carousel/index.css';
import actionbutton from './components/components/actionbutton.vue'

Vue.component('actionbutton', actionbutton);

Vue.component('SsrCarousel', SsrCarousel);


Vue.use(VueMeta, {
  keyName: "metaInfo",
  ssrAttribute: "data-vue-meta-server-rendered",
  attribute: "data-vue-meta",
  refreshOnceOnNavigation: true,
  tagIDKeyName: "vmid",
  titleTemplate: (chunk) => (chunk ? `${chunk} | OddsGalore` : "OddsGalore"),

});



// import isSSR from './components/plugins/isSSR.js'
// // Install global $isSSR()
// Vue.use(isSSR)
import VueMq from 'vue-mq'

import createAxios from './components/plugins/axios.js'

import { createStore } from './store/store.js'

//npm plugins
Vue.use(VueRouter);
Vue.use(asyncComputed);

Vue.use(VueMq, {
    breakpoints: { // default breakpoints - customize this
      sm: 640,
      md: 1024,
      lg: 1366 
    },
    defaultBreakpoint: 'lg' // customize this for SSR
  })

export function createApp(context) {

  //store
const store = createStore() 

 //routes
const router = new VueRouter ({
    routes: routes,
    linkActiveClass: "active",
    mode: "history",
    scrollBehavior(to,from,savedPosition) {
   
        // document.getElementById("app").scrollIntoView();
        return { x: 0, y: 0 };
       
    }
})



  
 const isServer = typeof window === 'undefined'
  Vue.use(isServer ? globalmethods_ssr : globalmethods)
  
// Create axios instance and inject
const axios = createAxios(context ? context.apiBase : null)
Vue.prototype.$axios = axios

  const app = new Vue({
    router,
    store,
    render: h => h(App)
  })

  return { app, router, store, axios }
}








   

